import React from "react";

import { Grid } from "@mui/material";
import { Skeleton, Stack } from "@mui/material";

const SkeletonNotifications = () => {
  const heightText = 24;
  const heightDate = 20;
  const heightAvatar = 32;
  const widthAvatar = 32;

  return (
    <Grid container direction="row" style={{ padding: "16px 24px" }}>
      <Grid container item xs={1} direction="column">
        <Skeleton variant="circular" height={heightAvatar} width={widthAvatar} />
      </Grid>
      <Grid item xs={10}>
        <Stack direction="column">
          <Skeleton variant="text" height={heightText} width="100%" />
          <Skeleton variant="text" height={heightText} width="60%" />
          <Skeleton variant="text" height={heightDate} width="30%" />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SkeletonNotifications;
